
import React, { useEffect } from "react";

const GeoLocator = () => {
    const [lat, setLat] = React.useState(null);
    const [lng, setLng] = React.useState(null);
    const [status, setStatus] = React.useState(null);

    useEffect(() => {
        navigator.geolocation.watchPosition(function(position) {
            setStatus(true);
            setLat(position.coords.latitude);
            setLng(position.coords.longitude);
          }, function(error) {
            if (error.code === error.PERMISSION_DENIED)
                setStatus(false);
          });
    }, []);

    return (<div className='absolute top-20 text-center max-w-sm text-xs'>
        {status ? lat + ' ~ ' + lng : 'Abilita la geolocalizzazione per visualizzare la tua posizione corrente'}
    </div>);

}

export default GeoLocator